export const formatAudioPlayerTime = (time: number): string => {
  if (!Number.isFinite(time) || time < 0) {
    return '00:00'
  }

  const minutes = Math.floor(time / 60)
    .toString()
    .padStart(2, '0')
  const seconds = Math.floor(time % 60)
    .toString()
    .padStart(2, '0')
  return `${minutes}:${seconds}`
}

export const parseAudioPlayerSpeed = (speed: string): number => {
  const value = Number.parseFloat(speed.replace('x', ''))
  return Number.isFinite(value) && value > 0 ? value : 1
}
